import { TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE } from './TableModalPagination.constants'

function getLeftValue({ currentPage, pageCount }) {
  if (currentPage <= TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE) {
    return 1
  }

  if (
    currentPage >=
    pageCount - (TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE - 1)
  ) {
    return pageCount - (TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE - 1)
  }

  return currentPage
}

function getRightValue({ currentPage, pageCount }) {
  if (currentPage <= TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE) {
    return TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE
  }

  if (
    currentPage >=
    pageCount - (TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE - 1)
  ) {
    return pageCount
  }

  return currentPage
}

export function getTableModalPaginationPageList({ currentPage, pageCount }) {
  const pages = Array.from({ length: pageCount }, (v, k) => k + 1)
  const currentPageInt = parseInt(currentPage)

  if (pageCount <= TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE) {
    return pages
  }

  const list = []

  const left = getLeftValue({ currentPage: currentPageInt, pageCount })
  const right = getRightValue({ currentPage: currentPageInt, pageCount })

  for (let i = left; i <= right; i += 1) {
    list.push(i)
  }

  if (
    currentPageInt - 1 >= TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE &&
    currentPageInt !== TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE
  ) {
    list.unshift('prev')
  }

  if (
    pageCount - currentPageInt >= TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE &&
    currentPageInt !== pageCount - (TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE - 1)
  ) {
    list.push('next')
  }

  if (left !== 1) {
    list.unshift(1)
  }

  if (right !== pageCount) {
    list.push(pageCount)
  }

  return list
}
